import {useEffect, useRef} from 'react'
import Lottie from 'lottie-web'
import loadingAnimation from '../../asset/lotties/loading_animation.json'
import {RIF} from '../../lib'
import {selectLoading} from '../../store'
import _ from 'lodash'

export const Loading = () => {
  const loadingState = selectLoading()
  const isLoading = !_.isEmpty(loadingState)

  const animRef = useRef<HTMLDivElement>(null)

  useEffect(() => {
    if (!animRef.current) return
    const anim = Lottie.loadAnimation({
      container: animRef.current,
      renderer: 'svg',
      loop: true,
      autoplay: true,
      animationData: loadingAnimation,
    })
    return () => anim.stop()
  }, [isLoading])

  return (
    <>
      {RIF(
        isLoading,
        <div
          css={{
            position: 'fixed',
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            background: '#00000010',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            zIndex: 110,
          }}>
          <div ref={animRef} css={{width: '150px'}}></div>
        </div>,
      )}
    </>
  )
}
